import NoData from './NoData';
import './NoData.scss';

export default NoData;
